import gql from 'graphql-tag'

export const eventCodeDeprecate = gql`
  mutation eventCodeDeprecate($data: EventCodeDeprecateInput!) {
    eventCodeDeprecate(input: $data) {
      success
      newEventCodeId
    }
  }
`
